import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSchList, addSch, delSch } from "@/api/management/showcase";
export default {
  name: "Note",
  props: ["itemData", "type"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      value: new Date(),
      addDateShow: false,
      scheduleList: [],
      form: {
        title: "",
        type: "",
        timesHm: "",
        //时分选择
        timesYm: "",
        //年月日选择
        repeatFlag: "",
        repeatFlagDes: ""
      },
      flagForm: {
        times: "",
        repeatAppendWeeks: "",
        repeatAppendDays: "",
        repeatAppendMonths: ""
      },
      repeatAppendMonths: "",
      repeatAppendDays: "",
      repeatFlagList: [{
        value: "0",
        name: "一次性"
      }, {
        value: "1",
        name: "每天"
      }, {
        value: "2",
        name: "每周"
      }, {
        value: "3",
        name: "每月"
      }, {
        value: "4",
        name: "每年"
      }],
      formLabelWidth: "120px",
      rules: {
        title: [{
          required: true,
          message: "请输入日程标题",
          trigger: "blur"
        }, {
          min: 2,
          max: 10,
          message: "长度在 2 到 10 个字符",
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: "请输入日程内容",
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: "请选择类型",
          trigger: "change"
        }],
        repeatFlag: [{
          required: true,
          message: "请选择重复频率",
          trigger: "change"
        }],
        timesHm: [{
          type: "array",
          required: true,
          message: "请选择时分区间",
          fields: {
            //tpye类型试情况而定,所以如果返回的是date就改成date
            0: {
              type: "string",
              required: true,
              message: "请选择开始时分"
            },
            1: {
              type: "string",
              required: true,
              message: "请选择结束时分"
            }
          }
        }],
        timesYm: [{
          type: "array",
          required: true,
          message: "请选择日期区间",
          fields: {
            //tpye类型试情况而定,所以如果返回的是date就改成date
            0: {
              type: "string",
              required: true,
              message: "请选择开始日期"
            },
            1: {
              type: "string",
              required: true,
              message: "请选择结束日期"
            }
          }
        }]
      },
      flagRules: {
        repeatAppendWeeks: [{
          required: true,
          message: "请选择每周频率",
          trigger: "change"
        }],
        repeatAppendDays: [{
          required: true,
          message: "请输入每月频率",
          trigger: "blur"
        }],
        repeatAppendMonths: [{
          type: "date",
          required: true,
          message: "请选择每年频率",
          trigger: "change"
        }]
      }
    };
  },
  mounted: function mounted() {
    if (this.type == "index") {
      this.scheduleList = this.itemData.data;
    } else {
      this.getSchListData();
    }
  },
  methods: {
    getSchListData: function getSchListData() {
      var _this = this;

      var params = {
        len: 10000,
        pos: 0
      };
      getSchList(params).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.scheduleList = data.data;
        } else {
          _this.$message.error(data.msg);
        }
      });
    },
    flagChange: function flagChange(val) {
      var _this2 = this;

      this.repeatAppendMonths = "";
      this.repeatAppendDays = "";
      this.flagForm.repeatAppendDays = "";
      this.flagForm.repeatAppendWeeks = "";
      this.repeatFlagList.forEach(function (item) {
        if (item.value == val) {
          _this2.form.repeatFlagDes = item.name;
        }
      });
      this.$refs["flagForm"].resetFields();
    },
    addSc: function addSc() {
      this.addDateShow = true;
    },
    deleteSch: function deleteSch(item) {
      var _this3 = this;

      this.$confirm("\u786E\u5B9A\u5220\u9664".concat(item.title, "\u5417"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        delSch(item.id).then(function (_ref2) {
          var data = _ref2.data;

          if (data.code == 0) {
            _this3.$message({
              type: "success",
              message: "删除成功!"
            });

            _this3.getSchListData();
          } else {
            _this3.$message.error(data.msg);
          }
        });
      });
    },
    pickChange: function pickChange() {
      this.repeatAppendMonths = new Date(this.flagForm.repeatAppendMonths).getMonth() + 1;
      this.repeatAppendDays = new Date(this.flagForm.repeatAppendMonths).getDate();
    },
    submitForm: function submitForm(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this4.form.repeatFlag == 1 || _this4.form.repeatFlag == 0) {
            _this4.setForm();
          }

          if (_this4.form.repeatFlag == 2 || _this4.form.repeatFlag == 3 || _this4.form.repeatFlag == 4) {
            _this4.flagVali();
          }
        } else {
          return false;
        }
      });
    },
    flagVali: function flagVali() {
      var _this5 = this;

      if (this.form.repeatFlag == 2) {
        this.$refs["flagForm"].validateField("repeatAppendWeeks", function (valid) {
          if (valid) {
            return;
          } else {
            _this5.setForm();
          }
        });
      }

      if (this.form.repeatFlag == 3) {
        this.$refs["flagForm"].validateField("repeatAppendDays", function (valid) {
          if (valid) {
            return;
          } else {
            _this5.setForm();
          }
        });
      }

      if (this.form.repeatFlag == 4) {
        this.$refs["flagForm"].validateField("repeatAppendMonths", function (valid) {
          if (valid) {
            return;
          } else {
            _this5.setForm();
          }
        });
      }
    },
    setForm: function setForm() {
      var _this6 = this;

      var startTime = "";
      var endTime = "";

      if (this.form.repeatFlag == 0) {
        startTime = this.form.timesYm[0];
        endTime = this.form.timesYm[1];
      } else {
        startTime = this.form.timesHm[0];
        endTime = this.form.timesHm[1];
      }

      var params = {
        content: this.form.content || "",
        startTime: startTime || "",
        endTime: endTime || "",
        id: "",
        repeatAppendDays: this.flagForm.repeatAppendDays || this.repeatAppendDays || "",
        repeatAppendMonths: this.repeatAppendMonths || "",
        repeatAppendWeeks: this.flagForm.repeatAppendWeeks || "",
        repeatFlag: this.form.repeatFlag || "",
        repeatFlagDes: this.form.repeatFlagDes || "",
        title: this.form.title || "",
        type: this.form.type || ""
      };
      addSch(params).then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          _this6.getSchListData();

          _this6.addDateShow = false;

          _this6.$message.success("新增成功!");
        } else {
          _this6.$message.error(data.msg);
        }
      });
    },
    diaClose: function diaClose() {
      this.form.title = "";
      this.form.type = "";
      this.form.content = "";
      this.form.timesHm = "";
      this.form.timesYm = "";
      this.form.repeatFlag = "";
      this.form.repeatFlagDes = "";
      this.flagForm.repeatAppendWeeks = "";
      this.flagForm.repeatAppendDays = "";
      this.flagForm.repeatAppendMonths = "";
      this.$refs["form"].resetFields();
    }
  }
};